import posthog from "posthog-js";
import {
  FEATURE_FLAG_EXPIRY_DATE,
  USER_CREATION_CUTOFF_DATE
} from "./constants";
import { PromoFeatureName, PromoShouldApplyData, PromoType } from "./types";
import moment from "moment";
import { datadogRum } from "@datadog/browser-rum";

const checkCombinedIncomePromo = ({
  isBoomScreen,
  partnerCreatedAt,
  featureFlagEnabled,
  sessionPromoData
}: PromoShouldApplyData) => {
  const now = moment();
  const shouldHide = !!Number(sessionPromoData);

  if (
    !isBoomScreen ||
    now.isAfter(FEATURE_FLAG_EXPIRY_DATE) ||
    (partnerCreatedAt
      ? moment(partnerCreatedAt).isAfter(USER_CREATION_CUTOFF_DATE)
      : false)
  )
    return false;

  return Boolean(featureFlagEnabled && !shouldHide);
};

const RULES_PER_FEATURE = {
  [PromoFeatureName.CombinedIncome]: {
    [PromoType.Modal]: {
      shouldApply: checkCombinedIncomePromo
    },
    [PromoType.Banner]: {
      shouldApply: checkCombinedIncomePromo
    }
  }
};

export const shouldApplyPromo = (
  featureName: PromoFeatureName,
  type: PromoType,
  context: PromoShouldApplyData
) => RULES_PER_FEATURE[featureName][type].shouldApply(context);

export const cleanupPromoStorage = (featureName: PromoFeatureName) => {
  sessionStorage.removeItem("hidePromoModal");
  sessionStorage.removeItem("hidePromoBanner");
  localStorage.removeItem(`${featureName}_promoBannerSeenCount`);
};

export const markPromoAsSeen = (
  featureName: PromoFeatureName,
  type: PromoType
) => {
  const promoBannerSeenCount = localStorage.getItem(
    `${featureName}_promoBannerSeenCount`
  );
  let featureFlagPersonProperties;

  if (type === PromoType.Modal) {
    sessionStorage.setItem("hidePromoModal", "1");
    featureFlagPersonProperties = {
      $set_once: {
        [`${featureName}_seen_modal`]: true
      }
    };
  } else {
    const seenBannerCount = Number(promoBannerSeenCount) + 1;

    localStorage.setItem(
      `${featureName}_promoBannerSeenCount`,
      `${seenBannerCount}`
    );
    featureFlagPersonProperties = {
      $set: {
        [`${featureName}_seen_banner_count`]: seenBannerCount
      }
    };
  }

  sessionStorage.setItem("hidePromoBanner", "1");
  posthog.capture(
    `${featureName.toLocaleUpperCase()}_PROMO_${type.toLocaleUpperCase()}_CLOSE`,
    featureFlagPersonProperties
  );
};

const promoRUMTitleParts = {
  ["show"]: "show",
  ["action-click"]: "'watch demo' click",
  ["close-click"]: "close click"
};

export const trackPromoRUM = (
  featureName: PromoFeatureName,
  type: PromoType,
  actionType: "show" | "action-click" | "close-click"
) => {
  const title = `Promo: ${featureName.replaceAll("_", " ")} ${promoRUMTitleParts[actionType]}`;

  datadogRum.addAction(title, {
    featureName,
    type
  });
};
